<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT TARIKH AKHIR BERKHIDMAT </h3>
            <br />
            <div class="pl-lg-1">
                <validation-provider name="Amaun Telah Terima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Amaun Dalam Buku Servis* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-input v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)" style="width: 80%" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="radio" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5">  Sila Pilih * </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio v-model="Obj.StatusCatatan" :aria-describedby="ariaDescribedby" name="some-radios" value="1">Bersara</b-form-radio>
                                <b-form-radio v-model="Obj.StatusCatatan" :aria-describedby="ariaDescribedby" name="some-radios" value="2">Meninggal Dunia</b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-provider>

                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="5"> Tarikh Kuatkuasa* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <base-input type="date" v-model="Obj.EftDate" />
                        </b-col>
                    </b-row>
                </validation-provider>
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="5"> Catatan* </b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="6">
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder=""></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

            Obj: {
                Catatan: "Tarikh Bersara/Meninggal Dunia",
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemen181911(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
           });
        }

    },
    created() {}
}
</script>
